
define('template!mailsMailRightCollapsedPurchaseOrdersView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="header">\n    <div class="title">' +
((__t = ( _.i18n('common.order') )) == null ? '' : __t) +
'</div>\n</div>\n<div class="purchaseOrders-container"></div>';

}
return __p
};});

